import(/* webpackMode: "eager" */ "/vercel/path0/web/web/src/app/tools/calendar-templates/page.tsx");
